export default "__VITE_ASSET__BYMYJnoU__"